import { atom } from "recoil";

export const copyPasteChannelTypeState = atom<"Email" | "MobileNumber">({
  key: "ImportFile_copyPasteChannelTypeState",
  default: "Email",
});

export const copyPasteTextState = atom<string>({
  key: "ImportFile_copyPasteTextState",
  default: "",
});

export const copyPasteExtractedState = atom<string[]>({
  key: "ImportFile_copyPasteExtractedState",
  default: [],
});

export const copyPasteProcessedState = atom<boolean>({
  key: "ImportFile_copyPasteProcessedState",
  default: false,
});

export const copyPasteIsDirtyTextAreaState = atom<boolean>({
  key: "ImportFile_copyPasteIsDirtyTextAreaState",
  default: false,
});
